export const USA_ASSEMBLY_ID = 1;
export const CHINA_PCB_ID = 4;
export const TAWIAN_PCB_ID = 21;
export const USA_QUICKTURN_ID = 19;

export const findVariantIdBySupplierCode = (supplier) => {
  switch (supplier) {
    case 'fabrication-offshore-whx':
      return CHINA_PCB_ID;
    case 'fabrication-tw-offshore-jet-pcb':
      return TAWIAN_PCB_ID;
    default:
      return USA_QUICKTURN_ID; // USA Quickturn
  }
};
